// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","overlay":"G73cd84"};